import React, { FunctionComponent } from "react";
import { Form } from "@plex/react-components";
import "./DocumentPropertiesForm.scss";

/**
 * IDocumentPropertiesModel defines the structure for the document properties model.
 * It includes fields for the document's name and summary.
 */
export interface IDocumentPropertiesModel {
  name: string;
  summary: string;
}

/**
 * DocumentPropertiesForm is a React component that displays the properties of the flow document
 * in the Properties panel's Flow tab.
 *
 * @param {{ documentProperties: IDocumentPropertiesModel }} props - The document properties object.
 * @returns {React.JSX.Element} The rendered form component.
 */
export const DocumentPropertiesForm: FunctionComponent<{ documentProperties: IDocumentPropertiesModel }> = ({ documentProperties }): React.JSX.Element => {
  const { name, summary } = documentProperties;
  return (
    <Form className="flow-properties-form">
      <Form.Section title="Detail">
        <Form.Row>
          <Form.FieldPair labelText="Name" className="center-align">
            <div>{name}</div>
          </Form.FieldPair>
        </Form.Row>
        <Form.Row>
          <Form.FieldPair labelText="Summary" className="center-align">
            <div>{summary}</div>
          </Form.FieldPair>
        </Form.Row>
      </Form.Section>
    </Form>
  );
};
